import { render, staticRenderFns } from "./AcademicEnquiry.vue?vue&type=template&id=658121c8&scoped=true&"
import script from "./AcademicEnquiry.vue?vue&type=script&lang=js&"
export * from "./AcademicEnquiry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658121c8",
  null
  
)

export default component.exports